import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-5 right-5 z-[9999] flex flex-col gap-2 pointer-events-none" }
const _hoisted_2 = {
  key: 0,
  class: "w-5 h-5 text-green-500 shrink-0 mt-0.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = {
  key: 1,
  class: "w-5 h-5 text-red-500 shrink-0 mt-0.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = ["onClick"]

import { ref } from 'vue';

interface Toast {
  id: number;
  type: 'success' | 'error';
  message: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastNotification',
  setup(__props, { expose: __expose }) {

const toasts = ref<Toast[]>([]);
let counter = 0;

const add = (type: 'success' | 'error', message: string, duration = 4000) => {
  const id = ++counter;
  toasts.value.push({ id, type, message });
  setTimeout(() => remove(id), duration);
};

const remove = (id: number) => {
  toasts.value = toasts.value.filter(t => t.id !== id);
};

__expose({ add });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(["pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg text-sm font-medium min-w-[280px] max-w-[360px]", toast.type === 'success'
            ? 'bg-green-50 text-green-800 border border-green-200'
            : 'bg-red-50 text-red-800 border border-red-200'])
            }, [
              (toast.type === 'success')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 13l4 4L19 7"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    }, null, -1)
                  ]))])),
              _createElementVNode("span", _hoisted_4, _toDisplayString(toast.message), 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (remove(toast.id)),
                class: "text-current opacity-50 hover:opacity-100 transition-opacity"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))], 8, _hoisted_5)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})